import { useState } from 'react';

import FindingCard from './FindingCard';
import { SEVERITY_LABEL, Thread } from './watchdogUtils';

import styles from './Watchdog.module.scss';

/**
 * Groups an evolving story (quake -> rail suspension -> port closure -> services
 * resumed) under one parent with the latest status on top (§10.13). A single
 * finding renders as a plain card — no thread chrome.
 */
export default function FindingThread({ thread }: { thread: Thread }) {
	const [expanded, setExpanded] = useState(false);

	const [latest, ...older] = thread.findings;

	if (older.length === 0) {
		return <FindingCard finding={latest} />;
	}

	return (
		<section className={styles.thread}>
			<header className={styles['thread-head']}>
				<div className={styles['thread-heading']}>
					<h4 className={styles['thread-title']}>{thread.title}</h4>
					<span className={styles['thread-count']}>
						{thread.findings.length} updates
						{thread.resolved ? ' · latest: resolved' : ''}
						{SEVERITY_LABEL[thread.severity] ? ` · peak ${SEVERITY_LABEL[thread.severity]}` : ''}
					</span>
				</div>
				<button
					type="button"
					className={styles['thread-toggle']}
					onClick={() => setExpanded((value) => !value)}
					aria-expanded={expanded}
				>
					{expanded ? 'Hide earlier updates' : `Show ${older.length} earlier ${older.length === 1 ? 'update' : 'updates'}`}
					<span className="material-icons">{expanded ? 'expand_less' : 'expand_more'}</span>
				</button>
			</header>

			<FindingCard finding={latest} />

			{expanded && (
				<div className={styles['thread-updates']}>
					{older.map((finding) => (
						<FindingCard key={finding.id} finding={finding} />
					))}
				</div>
			)}
		</section>
	);
}
